import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "./About.css"
import Footer from '../Footer/Footer'
import NavBar from '../NavBar/NavBar'

const About = () => {
    return (
    <div className='about-kiga-main'>
         <NavBar/>
     
         <div className='about-kiga-slide-page' style={{background:`linear-gradient(to top, rgba(000, 000, 000, 0.52), rgba(000, 000, 000, 0.73)),
             url('images/moving2.jpg')`,
             backgroundAttachment:'fixed',
             backgroundRepeat:'no-repeat',
             backgroundSize:'cover',
             objectFit:'cover'
          }}>
          <div className='about-kiga-slide-page-title'>
                 <p>Kigali</p>
                 <p>International</p>
                 <p>Gymnastic Academy</p>
      
          </div>
         </div>
     
         <div className='about-kiga-overview-who'> 
      <div className='about-kiga-overview-who-content'>
         <div className="about-kiga-overview-who-content-title">
           <p>Who We Are</p>
         </div>
        <div className='about-kiga-overview-who-content-big-title'>
          <p>Kigali International<br/><span>Gymnastic Academy</span></p>
        </div>
        <div className='about-kiga-overview-who-content-small'>
          <p>
           At Kigali International Gymnastics Academy, we believe in the
                power of discipline, creativity, and perseverance. Founded with
                a passion for acrobatics and gymnastics arts, our academy is
                dedicated to training and inspiring the next generation of
                gymnasts and young athletes. Our specialized Coach is a well
                known figure in the field of Gymastics with more than 11 years
                of experience in coaching and training young talents. We provide a
                structured and supportive environment where students can develop
                their skills, confidence, and physical strength through
                Gymnastics and Acrobtics weekly classes. We are currently
                located at Nyarutarama Sports Center ( 22KG, 13 Avenue.
                Nyarutarama) well kow as Tennis Club.
          </p>
        </div>
        <div className='about-kiga-overview-who-content-button'>
          <p><Link to='/contact'>contact Us</Link></p>
        </div>
      </div>
      <div className='about-kiga-overview-who-count'>
          <div className='about-kiga-overview-who-count-flex'>
             <div className='about-kiga-overview-who-count-units'>
               <div className="about-kiga-overview-who-count-units-icon">
                 <i className="fa-solid fa-people-group"></i>
               </div>
                <div className='about-kiga-overview-who-count-units-numbers'>
                    <p>40+</p>
                </div>
                <div className='about-kiga-overview-who-count-units-title'>
                    <p>Kids</p>
                </div>
             </div>
             <div className='about-kiga-overview-who-count-client'>
             <div className="about-kiga-overview-who-count-units-icon">
                 <i className="fa-solid fa-people-group"></i>
               </div>
               <div className='about-kiga-overview-who-count-client-number'> 
                  <p>30+</p>
               </div>
               <div className='about-kiga-overview-who-count-client-title'>
                 <p>Satisfied Parents</p>
               </div>
             </div>
          </div>
      </div>
    </div>
  {/*
    <div className='about-kiga-overview-trust'>
      <div className="about-kiga-overview-trust-big-title">
        <p>Why Trust Kiga,<br/>Right</p>
      </div>
     </div>

     <div className='about-kiga-overview-banner1-left'>
      <div className="about-kiga-overview-banner1-left-image">
        <div className='about-kiga-overview-banner-image'>
        <img src='/images/acrobat1.jpg' alt='right-1'/>
         </div>
      </div>
     <div className='about-kiga-overview-banner1-left-content'>
         <div className='about-kiga-overview-banner1-left-title'>
         <p>Gymster</p>
         </div>
         <div className='about-kiga-overview-banner1-content'>
         <p>Foundational movement skills in a safe & positive environment.</p>
         <p>Ages 18mo - 5yrs.</p>
         </div>
         <div className='about-kiga-overview-banner1-left-button'>
            <p>Read More</p>
         </div>
     </div>
     </div>


     <div className='about-kiga-overview-banner2-right'>
     <div className='about-kiga-overview-banner2-right-content'>
         <div className='about-kiga-overview-banner2-right-title'>
             <p>Team</p>
         </div>
         <div className='about-kiga-overview-banner2-content'>
            <p>Competitive and Pre-Competitive Acrobatic Gymnastics teams.</p>
            <p>Advance</p>
         </div>
         <div className='about-kiga-overview-banner2-right-button'>
            <p>Read More</p>
         </div>
     </div>
     <div className="about-kiga-overview-banner3-right-image">
        <div className='about-kiga-overview-banner2-image'>
        <img src='/images/acrobat3.jpg' alt='left'/>
         </div>
      </div>
     </div>
    
     <div className='about-kiga-overview-banner1-left'>
     <div className="about-kiga-overview-banner1-left-image">
        <div className='about-kiga-overview-banner-image'>
        <img src='/images/acrobat2.jpg' alt='lef2'/>
         </div>
      </div>
     <div className='about-kiga-overview-banner1-left-content'>
         <div className='about-kiga-overview-banner1-left-title'>
            <p>Recreational</p>
         </div>
         <div className='about-kiga-overview-banner1-content'>
            <p>The perfect mix of fun and world-class tumbling technique.</p>
            <p>Ages 4 and up.</p>
         </div>
         <div className='about-kiga-overview-banner1-left-button'>
            <p>Read More</p>
         </div>
     </div>
     </div>
     */}
     <Footer/>
  </div>
       )
}

export default About
